/* Cart Drawer Pro - MeraFashion. SneakerAsk-style cart drawer logic. */
(function () {
  'use strict';

  var root = document.getElementById('CartDrawerPro');
  if (!root || root.dataset.cdpBooted) return;
  root.dataset.cdpBooted = '1';

  var DQ = String.fromCharCode(34);

  function readJSON(id, fallback) {
    var el = document.getElementById(id);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }

  var CFG = readJSON('CartDrawerProConfig', {});
  var $ = function (sel, ctx) { return (ctx || root).querySelector(sel); };

  var els = {
    body: $('[data-cdp-body]'),
    items: $('[data-cdp-items]'),
    empty: $('[data-cdp-empty]'),
    count: $('[data-cdp-count]'),
    total: $('[data-cdp-total]'),
    footer: $('[data-cdp-footer]'),
    recs: $('[data-cdp-recs]'),
    rail: $('[data-cdp-recs-rail]'),
    thumb: $('[data-cdp-recs-thumb]'),
    prev: $('[data-cdp-recs-prev]'),
    next: $('[data-cdp-recs-next]'),
    shipbar: $('[data-cdp-shipbar]'),
    shipText: $('[data-cdp-shipbar-text]'),
    shipFill: $('[data-cdp-shipbar-fill]'),
    urgency: $('[data-cdp-urgency]'),
    checkout: $('[data-cdp-checkout]')
  };

  var state = { cart: null, scrollY: 0, tagCache: {}, recsFor: null };

  var RE_THOUSANDS = new RegExp('([0-9])(?=([0-9][0-9][0-9])+(?![0-9]))', 'g');
  var RE_PLACEHOLDER = new RegExp('[{][{][ ]*([a-z_]+)[ ]*[}][}]', 'g');
  var RE_IMG_SIZE = new RegExp('([.](png|jpe?g|webp|gif))([?]|$)', 'i');
  var RE_AMP = new RegExp('&', 'g');
  var RE_LT = new RegExp('<', 'g');
  var RE_GT = new RegExp('>', 'g');
  var RE_DQ = new RegExp(DQ, 'g');
  var RE_SQ = new RegExp(String.fromCharCode(39), 'g');

  var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1); };

  /* ------------------------------------------------------------------ *
   * Checkout button state.
   * The button is set to is-loading while the browser navigates to
   * /checkout. If the customer hits Back, the page is restored from the
   * bfcache with that class still applied - which left the button
   * spinning and unclickable. Reset it on every path back into view.
   * ------------------------------------------------------------------ */
  function resetCheckout() {
    if (els.checkout) els.checkout.classList.remove('is-loading');
  }

  window.addEventListener('pageshow', function () { resetCheckout(); });
  window.addEventListener('popstate', resetCheckout);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') resetCheckout();
  });
  window.addEventListener('focus', resetCheckout);

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(RE_AMP, '&amp;')
      .replace(RE_LT, '&lt;')
      .replace(RE_GT, '&gt;')
      .replace(RE_DQ, '&quot;')
      .replace(RE_SQ, '&#39;');
  }

  function formatMoney(cents) {
    cents = Number(cents) || 0;
    var fmt = CFG.moneyFormat || '{{amount_with_comma_separator}}';
    function num(value, precision, thousands, decimal) {
      var parts = (value / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(RE_THOUSANDS, '$1' + thousands);
      return precision ? whole + decimal + parts[1] : whole;
    }
    return fmt.replace(RE_PLACEHOLDER, function (m, key) {
      switch (key) {
        case 'amount': return num(cents, 2, ',', '.');
        case 'amount_no_decimals': return num(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return num(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(cents, 0, '.', ',');
        case 'amount_with_space_separator': return num(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return num(cents, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return num(cents, 2, String.fromCharCode(39), '.');
        default: return num(cents, 2, ',', '.');
      }
    });
  }

  function moneyHTML(cents) {
    var c = Number(cents) || 0;
    return `<span class='money' data-money-convertible doubly-currency-${esc(CFG.currency)}='${c}'>${formatMoney(c)}</span>`;
  }

  function sized(url, size) {
    if (!url) return '';
    return String(url).replace(RE_IMG_SIZE, '_' + size + '$1$3');
  }

  var toastEl = null, toastTimer = null;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'cdp-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  function isProtection(item) {
    return !!CFG.protectionVariantId && Number(item.variant_id) === Number(CFG.protectionVariantId);
  }
  function isGift(item) {
    return !!CFG.giftVariantId && Number(item.variant_id) === Number(CFG.giftVariantId);
  }
  function realCount(cart) {
    return (cart.items || []).reduce(function (n, i) {
      return n + (isProtection(i) || isGift(i) ? 0 : i.quantity);
    }, 0);
  }
  function subtotalWithoutExtras(cart) {
    return (cart.items || []).reduce(function (n, i) {
      return n + (isProtection(i) || isGift(i) ? 0 : i.final_line_price);
    }, 0);
  }
  function protectionDeclined() {
    try { return sessionStorage.getItem('cdp_protect_off') === '1'; } catch (e) { return false; }
  }
  function setProtectionDeclined(v) {
    try {
      if (v) { sessionStorage.setItem('cdp_protect_off', '1'); }
      else { sessionStorage.removeItem('cdp_protect_off'); }
    } catch (e) {}
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function postJSON(url, payload) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error((data && (data.description || data.message)) || 'Cart error');
        return data;
      });
    });
  }

  function changeLine(key, qty) { return postJSON('/cart/change.js', { id: key, quantity: qty }); }
  function addVariant(id, qty) { return postJSON('/cart/add.js', { items: [{ id: Number(id), quantity: qty || 1 }] }); }

  function reconcileAddons(cart) {
    var jobs = [];
    var items = cart.items || [];
    var real = realCount(cart);

    if (CFG.protectionVariantId) {
      var pLine = null;
      items.forEach(function (i) { if (isProtection(i)) { pLine = i; } });
      if (real === 0 && pLine) {
        jobs.push(function () { return changeLine(pLine.key, 0); });
      } else if (real > 0 && !pLine && CFG.protectionDefaultOn && !protectionDeclined()) {
        jobs.push(function () { return addVariant(CFG.protectionVariantId, 1); });
      } else if (pLine && pLine.quantity > 1) {
        jobs.push(function () { return changeLine(pLine.key, 1); });
      }
    }

    if (CFG.giftVariantId && CFG.giftThreshold > 0) {
      var gLine = null;
      items.forEach(function (i) { if (isGift(i)) { gLine = i; } });
      var sub = subtotalWithoutExtras(cart);
      if (sub >= CFG.giftThreshold && !gLine && real > 0) {
        jobs.push(function () { return addVariant(CFG.giftVariantId, 1); });
      } else if ((sub < CFG.giftThreshold || real === 0) && gLine) {
        jobs.push(function () { return changeLine(gLine.key, 0); });
      }
    }

    if (!jobs.length) return Promise.resolve(cart);

    return jobs.reduce(function (chain, job) {
      return chain.then(job).catch(function () { return null; });
    }, Promise.resolve()).then(getCart);
  }

  function protectionIcon() {
    return `<span class='cdp__item-img cdp__item-img--ph' aria-hidden='true'>
      <svg viewBox='0 0 48 48' width='44' height='44' fill='none'>
        <path d='M6 16.5 24 8l18 8.5v15L24 40 6 31.5z' fill='#E7C9A5'/>
        <path d='M6 16.5 24 25l18-8.5' stroke='#C79A66' stroke-width='1.6'/>
        <path d='M24 25v15' stroke='#C79A66' stroke-width='1.6'/>
        <path d='M24 4.5 33 8v6.2c0 5.4-3.6 10.2-9 11.8-5.4-1.6-9-6.4-9-11.8V8z' fill='#2F6BFF'/>
        <path d='m19.6 14.6 3 3 5.8-5.8' stroke='#fff' stroke-width='2.2' stroke-linecap='round' stroke-linejoin='round'/>
      </svg></span>`;
  }

  function itemHTML(item) {
    var protect = isProtection(item);
    var gift = isGift(item);
    var img = item.image ? sized(item.image, '240x') : '';

    var badge = '';
    if (!protect && !gift && state.tagCache[item.handle] === true) {
      badge = `<span class='cdp__item-badge'><svg viewBox='0 0 24 24' width='9' height='9' fill='currentColor'><path d='M13 2 4 14h6l-1 8 9-12h-6z'/></svg>${esc(CFG.badgeLabel || '48H')}</span>`;
    }

    var media = protect
      ? protectionIcon()
      : (img
        ? `<img class='cdp__item-img' src='${esc(img)}' alt='${esc(item.product_title)}' loading='lazy' decoding='async' width='88' height='88'>`
        : `<span class='cdp__item-img cdp__item-img--ph'></span>`);

    var titleTag = protect
      ? `<p class='cdp__item-title'>${esc(item.product_title)}</p>`
      : `<a class='cdp__item-title' href='${esc(item.url)}'>${esc(item.product_title)}</a>`;

    var variant = (!protect && !item.product_has_only_default_variant && item.variant_title)
      ? `<p class='cdp__item-variant'>${esc(item.variant_title)}</p>`
      : '';

    var props = '';
    if (item.properties) {
      var rows = Object.keys(item.properties)
        .filter(function (k) { return k.charAt(0) !== '_' && item.properties[k]; })
        .map(function (k) { return `<li>${esc(k)}: ${esc(item.properties[k])}</li>`; });
      if (rows.length) props = `<ul class='cdp__item-props'>${rows.join('')}</ul>`;
    }

    var price = item.original_line_price > item.final_line_price
      ? `<s>${moneyHTML(item.original_line_price)}</s>${moneyHTML(item.final_line_price)}`
      : moneyHTML(item.final_line_price);

    var qty = (protect || gift)
      ? `<span></span>`
      : `<div class='cdp__qty'>
          <button type='button' data-cdp-qty='${esc(item.key)}' data-to='${item.quantity - 1}' aria-label='Decrease quantity'>&minus;</button>
          <span class='cdp__qty-val'>${item.quantity}</span>
          <button type='button' data-cdp-qty='${esc(item.key)}' data-to='${item.quantity + 1}' aria-label='Increase quantity'>+</button>
        </div>`;

    return `<div class='cdp__item${protect ? ' cdp__item--protect' : ''}' data-key='${esc(item.key)}'>
      <div class='cdp__item-media'>${badge}${media}</div>
      <div class='cdp__item-main'>${titleTag}${variant}${props}</div>
      <div class='cdp__item-side'>
        <button type='button' class='cdp__item-remove' data-cdp-remove='${esc(item.key)}' aria-label='Remove'>
          <svg viewBox='0 0 24 24' width='15' height='15' fill='none' stroke='currentColor' stroke-width='1.7' stroke-linecap='round' stroke-linejoin='round'><path d='M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14'/></svg>
        </button>
      </div>
      <div class='cdp__item-bottom'>${qty}<span class='cdp__item-price'>${price}</span></div>
    </div>`;
  }

  function renderShipbar(cart) {
    if (!els.shipbar || !CFG.shippingThreshold) return;
    if (!cart.item_count) { els.shipbar.hidden = true; return; }
    els.shipbar.hidden = false;
    var sub = subtotalWithoutExtras(cart);
    var pct = Math.min(100, Math.round((sub / CFG.shippingThreshold) * 100));
    els.shipFill.style.width = pct + '%';
    if (sub >= CFG.shippingThreshold) {
      els.shipText.innerHTML = `<b>${esc(CFG.freeText)}</b>`;
    } else {
      els.shipText.innerHTML = esc(CFG.awayText).replace('[amount]', `<b>${moneyHTML(CFG.shippingThreshold - sub)}</b>`);
    }
  }

  function syncBubbles(count) {
    document.querySelectorAll('[data-cart-count], .Header__CartCount, .cart-count-bubble span, [data-header-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
    document.querySelectorAll('.OlyxHeader__CartDot').forEach(function (el) {
      el.classList.toggle('is-visible', count > 0);
    });
  }

  function loadTags(items) {
    var todo = items.filter(function (i) {
      return i.handle && !isProtection(i) && state.tagCache[i.handle] === undefined;
    });
    if (!todo.length) return;
    todo.forEach(function (i) { state.tagCache[i.handle] = null; });
    idle(function () {
      Promise.all(todo.map(function (i) {
        return fetch('/products/' + i.handle + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (p) {
            var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
            state.tagCache[i.handle] = tags.indexOf(String(CFG.badgeTag || '48h').toLowerCase()) !== -1;
          })
          .catch(function () { state.tagCache[i.handle] = false; });
      })).then(function () {
        var any = todo.some(function (i) { return state.tagCache[i.handle] === true; });
        if (any && state.cart && (state.cart.items || []).length) {
          els.items.innerHTML = state.cart.items.map(itemHTML).join('');
        }
      });
    });
  }

  function render(cart) {
    state.cart = cart;
    var items = cart.items || [];

    if (els.count) els.count.textContent = '(' + cart.item_count + ')';
    els.items.innerHTML = items.map(itemHTML).join('');
    if (els.empty) els.empty.hidden = items.length > 0;
    if (els.footer) els.footer.hidden = items.length === 0;
    if (els.total) els.total.innerHTML = moneyHTML(cart.total_price);
    if (els.urgency) els.urgency.hidden = items.length === 0;

    renderShipbar(cart);
    syncBubbles(cart.item_count);
    loadTags(items);
    if (CFG.showRecs) idle(function () { loadRecs(cart); });

    document.dispatchEvent(new CustomEvent('cdp:updated', { detail: { cart: cart } }));
  }

  function recHTML(p) {
    var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
    if (!v) return '';
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var price = (v.price != null ? v.price : p.price);
    var compare = (v.compare_at_price && v.compare_at_price > v.price)
      ? `<s>${moneyHTML(v.compare_at_price)}</s>`
      : '';
    var media = img
      ? `<img class='cdp__rec-img' src='${esc(sized(img, '160x'))}' alt='${esc(p.title)}' loading='lazy' decoding='async' width='62' height='62'>`
      : `<span class='cdp__rec-img'></span>`;
    return `<div class='cdp__rec'>${media}
      <div class='cdp__rec-body'>
        <a class='cdp__rec-title' href='${esc(p.url || ('/products/' + p.handle))}'>${esc(p.title)}</a>
        <span class='cdp__rec-price'>${moneyHTML(price)}${compare}</span>
      </div>
      <button type='button' class='cdp__rec-add' data-cdp-rec-add='${v.id}'>Add</button>
    </div>`;
  }

  function paintRecs(products, inCartIds) {
    var seen = {};
    var list = (products || []).filter(function (p) {
      if (!p || !p.variants || !p.variants.length) return false;
      if (seen[p.id]) return false;
      if (inCartIds.indexOf(Number(p.id)) !== -1) return false;
      if (CFG.protectionVariantId && p.variants.some(function (v) { return Number(v.id) === Number(CFG.protectionVariantId); })) return false;
      if (p.available === false) return false;
      seen[p.id] = 1;
      return true;
    }).slice(0, 8);

    if (!list.length) { els.recs.hidden = true; return; }
    els.rail.innerHTML = list.map(recHTML).join('');
    els.recs.hidden = false;
    els.rail.scrollLeft = 0;
    updateRail();
  }

  function loadRecs(cart) {
    if (!els.recs) return;
    var items = (cart.items || []).filter(function (i) { return !isProtection(i) && !isGift(i); });
    if (!items.length) { els.recs.hidden = true; return; }

    var inCartIds = (cart.items || []).map(function (i) { return Number(i.product_id); });
    var seed = items[items.length - 1].product_id;
    if (state.recsFor === seed && els.rail.children.length) { els.recs.hidden = false; return; }
    state.recsFor = seed;

    var base = '/recommendations/products.json?product_id=' + seed + '&limit=10&intent=';

    fetch(base + 'complementary', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var prods = (d && d.products) || [];
        if (prods.length >= 2) return prods;
        return fetch(base + 'related', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (d2) { return prods.concat((d2 && d2.products) || []); })
          .catch(function () { return prods; });
      })
      .then(function (prods) {
        if (prods.length >= 2 || !CFG.recsCollection) return prods;
        return fetch('/collections/' + CFG.recsCollection + '/products.json?limit=10', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (d3) {
            var extra = ((d3 && d3.products) || []).map(function (p) {
              return {
                id: p.id,
                title: p.title,
                handle: p.handle,
                url: '/products/' + p.handle,
                featured_image: (p.images && p.images[0] && p.images[0].src) || '',
                available: true,
                variants: (p.variants || []).map(function (v) {
                  return {
                    id: v.id,
                    price: Math.round(parseFloat(v.price) * 100),
                    available: v.available !== false,
                    compare_at_price: v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : null
                  };
                })
              };
            });
            return prods.concat(extra);
          })
          .catch(function () { return prods; });
      })
      .then(function (prods) { paintRecs(prods, inCartIds); })
      .catch(function () { els.recs.hidden = true; });
  }

  function updateRail() {
    if (!els.rail || !els.thumb) return;
    var max = els.rail.scrollWidth - els.rail.clientWidth;
    var n = els.rail.children.length || 1;
    var w = Math.max(18, 100 / n);
    els.thumb.style.width = w + '%';
    var ratio = max > 0 ? els.rail.scrollLeft / max : 0;
    els.thumb.style.transform = 'translateX(' + (ratio * ((100 / w) - 1) * 100) + '%)';
    if (els.prev) els.prev.disabled = els.rail.scrollLeft <= 2;
    if (els.next) els.next.disabled = max <= 0 || els.rail.scrollLeft >= max - 2;
  }

  if (els.rail) {
    els.rail.addEventListener('scroll', function () { requestAnimationFrame(updateRail); }, { passive: true });
    if (els.prev) els.prev.addEventListener('click', function () { els.rail.scrollBy({ left: -els.rail.clientWidth, behavior: 'smooth' }); });
    if (els.next) els.next.addEventListener('click', function () { els.rail.scrollBy({ left: els.rail.clientWidth, behavior: 'smooth' }); });
  }

  function refresh(skipAddons) {
    return getCart()
      .then(function (cart) { return skipAddons ? cart : reconcileAddons(cart); })
      .then(render)
      .catch(function () {});
  }

  function open() {
    if (root.classList.contains('is-open')) return;
    resetCheckout();
    state.scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    root.setAttribute('aria-hidden', 'false');
    root.classList.add('is-open');
    document.documentElement.classList.add('cdp-locked');
    document.body.classList.add('cdp-locked');
    document.body.style.top = '-' + state.scrollY + 'px';
    refresh();
    setTimeout(function () { var c = $('.cdp__close'); if (c) c.focus({ preventScroll: true }); }, 340);
  }

  function close() {
    if (!root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cdp-locked');
    document.body.classList.remove('cdp-locked');
    document.body.style.top = '';
    window.scrollTo(0, state.scrollY);
    resetCheckout();
  }

  window.olyxOpenCartDrawer = open;
  window.cdpOpenCart = open;
  window.cdpCloseCart = close;

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-cdp-close]')) { e.preventDefault(); close(); return; }

    var remove = e.target.closest('[data-cdp-remove]');
    if (remove) {
      e.preventDefault();
      var key = remove.getAttribute('data-cdp-remove');
      var line = ((state.cart && state.cart.items) || []).filter(function (i) { return i.key === key; })[0];
      if (line && isProtection(line)) setProtectionDeclined(true);
      var row = remove.closest('.cdp__item');
      if (row) row.classList.add('is-busy');
      changeLine(key, 0).then(function () { return refresh(); }).catch(function () { return refresh(); });
      return;
    }

    var qty = e.target.closest('[data-cdp-qty]');
    if (qty) {
      e.preventDefault();
      var to = parseInt(qty.getAttribute('data-to'), 10);
      var k = qty.getAttribute('data-cdp-qty');
      var row2 = qty.closest('.cdp__item');
      if (row2) row2.classList.add('is-busy');
      changeLine(k, Math.max(0, to)).then(function () { return refresh(); }).catch(function () { return refresh(); });
      return;
    }

    var recAdd = e.target.closest('[data-cdp-rec-add]');
    if (recAdd) {
      e.preventDefault();
      var vid = recAdd.getAttribute('data-cdp-rec-add');
      var label = recAdd.textContent;
      recAdd.disabled = true;
      recAdd.textContent = 'Adding';
      addVariant(vid, 1)
        .then(function () {
          recAdd.classList.add('is-added');
          recAdd.textContent = 'Added';
          state.recsFor = null;
          return refresh();
        })
        .catch(function (err) { toast(err.message || 'Could not add item'); recAdd.textContent = label; })
        .then(function () { setTimeout(function () { recAdd.disabled = false; }, 400); });
      return;
    }

    var dToggle = e.target.closest('[data-cdp-discount-toggle]');
    if (dToggle) {
      e.preventDefault();
      var panel = $('[data-cdp-discount-panel]');
      if (panel) {
        panel.hidden = !panel.hidden;
        if (!panel.hidden) { var di = $('[data-cdp-discount-input]'); if (di) di.focus(); }
      }
      return;
    }

    if (e.target.closest('[data-cdp-discount-apply]')) { e.preventDefault(); applyDiscount(); return; }

    if (e.target.closest('[data-cdp-checkout]')) {
      e.preventDefault();
      els.checkout.classList.add('is-loading');
      /* Safety net: if navigation is cancelled or blocked, give the button back. */
      setTimeout(resetCheckout, 6000);
      window.location.href = '/checkout';
      return;
    }
  });

  var dInput = $('[data-cdp-discount-input]');
  if (dInput) {
    dInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); applyDiscount(); }
    });
  }

  function applyDiscount() {
    var input = $('[data-cdp-discount-input]');
    var msg = $('[data-cdp-discount-msg]');
    if (!input || !input.value.trim() || !msg) return;
    var code = input.value.trim();
    msg.hidden = false;
    msg.className = 'cdp__discount-msg';
    msg.textContent = 'Checking...';
    fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .then(function () { return getCart(); })
      .then(function (cart) {
        var ok = (cart.discount_codes || []).some(function (d) {
          return String(d.code).toLowerCase() === code.toLowerCase() && d.applicable !== false;
        }) || cart.total_discount > 0;
        msg.className = 'cdp__discount-msg ' + (ok ? 'is-ok' : 'is-err');
        msg.textContent = ok ? 'Discount applied' : 'That code is not valid for this cart';
        render(cart);
      })
      .catch(function () {
        msg.className = 'cdp__discount-msg is-err';
        msg.textContent = 'Could not apply that code';
      });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  var overlay = $('.cdp__overlay');
  if (overlay) overlay.addEventListener('touchmove', function (e) { e.preventDefault(); }, { passive: false });

  document.addEventListener('click', function (e) {
    var a = e.target.closest(`a[href$='/cart'], a[href*='/cart?'], [data-cdp-open]`);
    if (!a) return;
    if (a.getAttribute('target') === '_blank') return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    open();
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    if (form.hasAttribute('data-cdp-ignore')) return;
    e.preventDefault();

    var btn = form.querySelector(`[type='submit'], button:not([type='button'])`);
if (btn) { btn.setAttribute('disabled', 'disabled'); btn.classList.add('is-loading'); }

open();          // ← ADD THIS: drawer opens instantly

fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok) throw new Error(d.description || d.message || 'Sold out');
          return d;
        });
      })
      .then(function () { setProtectionDeclined(false); state.recsFor = null; return refresh(); })
      .then(function () { open(); })
      .catch(function (err) { toast(err.message || 'Could not add to cart'); })
      .then(function () {
        if (btn) { btn.removeAttribute('disabled'); btn.classList.remove('is-loading'); }
      });
  }, true);

  ['cart:refresh', 'cart:updated', 'cart:build'].forEach(function (evt) {
    document.addEventListener(evt, function () { refresh(true); });
  });

  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(true); });
  window.addEventListener('resize', function () { requestAnimationFrame(updateRail); }, { passive: true });

  var seedCart = readJSON('CartDrawerProCart', { items: [], item_count: 0, total_price: 0 });
  render(seedCart);
  if (seedCart.item_count > 0) {
    idle(function () { reconcileAddons(seedCart).then(function (c) { if (c) render(c); }); });
  }

  resetCheckout();

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () { refresh(true); });
  }
})();